export default "__VITE_ASSET__CaXRYLQp__"